package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings
import er.prateek.crossly.data.model.ContentManifest
import er.prateek.crossly.data.model.CrosswordPack
import er.prateek.crossly.data.model.Puzzle
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

private val cacheJson = Json { ignoreUnknownKeys = true }
private const val KEY_MANIFEST = "content_cache_manifest"
private const val KEY_PACK_PREFIX = "content_cache_pack_"
private const val KEY_DAILY = "content_cache_daily"

@Serializable
private data class DailyPuzzleCacheEntry(val dateIso: String, val puzzle: Puzzle)

class SettingsContentCacheStore(
    private val settings: Settings,
) : ContentCacheStore {
    override fun loadManifest(): ContentManifest? {
        val raw = settings.getStringOrNull(KEY_MANIFEST) ?: return null
        return runCatching { cacheJson.decodeFromString(ContentManifest.serializer(), raw) }.getOrNull()
    }

    override fun saveManifest(manifest: ContentManifest) {
        settings.putString(KEY_MANIFEST, cacheJson.encodeToString(ContentManifest.serializer(), manifest))
    }

    override fun loadPack(packId: String): CrosswordPack? {
        val raw = settings.getStringOrNull(KEY_PACK_PREFIX + packId) ?: return null
        return runCatching { cacheJson.decodeFromString(CrosswordPack.serializer(), raw) }.getOrNull()
    }

    override fun savePack(pack: CrosswordPack) {
        settings.putString(KEY_PACK_PREFIX + pack.packId, cacheJson.encodeToString(CrosswordPack.serializer(), pack))
    }

    override fun loadDailyPuzzle(dateIso: String): Puzzle? {
        val raw = settings.getStringOrNull(KEY_DAILY) ?: return null
        val entry = runCatching { cacheJson.decodeFromString(DailyPuzzleCacheEntry.serializer(), raw) }.getOrNull()
        return entry?.takeIf { it.dateIso == dateIso }?.puzzle
    }

    override fun saveDailyPuzzle(dateIso: String, puzzle: Puzzle) {
        val entry = DailyPuzzleCacheEntry(dateIso, puzzle)
        settings.putString(KEY_DAILY, cacheJson.encodeToString(DailyPuzzleCacheEntry.serializer(), entry))
    }
}
